import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

export function configureStore({
  reducer,
  preloadedState,
  thunkExtraArgument,
}) {
  const enhancer = composeWithDevTools(applyMiddleware(thunk.withExtraArgument(thunkExtraArgument)));

  return createStore(reducer, preloadedState, enhancer);
}
